let currentQuestionNumber = 1;
const QUESTION_PREFIX = document.querySelector(".main-quiz-page-container")
  .dataset.questionText;

const selectAnswer = (
  currentButton,
  questionElement,
  questionsBoxes,
  questionContainer
) => {
  const actionType = currentButton.dataset.actionType;

  // Mark current question as answered
  questionElement.classList.add("not-answered-question");
  setTimeout(() => {
    questionElement.classList.remove("not-answered-question");
    questionElement.classList.add("position-right-outside");
  }, 500);

  // Handle the answer based on action type
   if (actionType === "question") {
    const nextQuestionId = currentButton.dataset.nextQuestion;
    if (nextQuestionId) {
      const nextQuestion = document.querySelector(
        `[data-question-id="${nextQuestionId}"]`
      );
      if (nextQuestion) {
        currentQuestionNumber++;
        handleQuestionNumber(nextQuestion);

        questionsBoxes.forEach((questionBox) => {
          questionBox.classList.add("not-answered-question");
        });
        nextQuestion.classList.remove("not-answered-question");
        nextQuestion.classList.add("position-right-outside");

        setTimeout(() => {
          nextQuestion.classList.remove("position-right-outside");
        }, 500);

        handleGoBackButton(nextQuestion, questionElement, questionContainer);
      }
    }
  }
};

const handleGoBackButton = (
  questionElement,
  questionElementToReturn,
  questionContainer
) => {
  const goBackButton = questionElement.querySelector(".question-go-back-btn");
  goBackButton.setAttribute(
    "data-previous-question-id",
    questionElementToReturn.dataset.questionId
  );
  if (goBackButton) {
    // Remove any existing click event listeners
    const newGoBackButton = goBackButton.cloneNode(true);
    goBackButton.parentNode.replaceChild(newGoBackButton, goBackButton);

    newGoBackButton.addEventListener("click", () => {
      const previousQuestion = document.querySelector(
        `[data-question-id="${newGoBackButton.dataset.previousQuestionId}"]`
      );
      if (previousQuestion) {
        currentQuestionNumber--;
        previousQuestion.classList.remove("position-right-outside");
        previousQuestion.classList.remove("not-answered-question");
        questionElement.classList.add("position-right-outside");
        questionContainer.style.minHeight = `${previousQuestion.offsetHeight}px`;
        handleQuestionNumber(previousQuestion);
      }
    });
  }
};

window.addEventListener("DOMContentLoaded", () => {
  const questionContainer = document.querySelector(".questions-container");
  const questionsBoxes = document.querySelectorAll(".question");
  const startQuizButtonWrapper = document.querySelector(
    ".button-start-quiz-wrapper"
  );
  const startQuizButton =
    startQuizButtonWrapper.querySelector(".button-start-quiz");
  const pageDescriptionWrapper = document.querySelector(
    ".page-description-wrapper"
  );
  const mainContentWrapper = document.querySelector(
    ".main-quiz-page-container .main-content-wrapper"
  );

  startQuizButton.addEventListener("click", () => {
    pageDescriptionWrapper.style.display = "none";
    startQuizButtonWrapper.style.display = "none";
    mainContentWrapper.classList.add("quiz-started");
    currentQuestionNumber = 1;

    const firstQuestion = document.querySelector(".question");
    if (firstQuestion) {
      firstQuestion.classList.remove("not-answered-question");
      firstQuestion.classList.add("position-right-outside");
      questionContainer.style.minHeight = `${firstQuestion.offsetHeight}px`;
      const firstButtonGoBack = firstQuestion.querySelector(
        ".question-go-back-btn"
      );

      handleQuestionNumber(firstQuestion);

      if (firstButtonGoBack) {
        firstButtonGoBack.addEventListener("click", () => {
          firstQuestion.classList.remove("not-answered-question");
          firstQuestion.classList.add("position-right-outside");
          questionContainer.style.minHeight = `0px`;
          pageDescriptionWrapper.style.display = "flex";
          startQuizButtonWrapper.style.display = "block";
          mainContentWrapper.classList.remove("quiz-started");
          currentQuestionNumber = 1;
        });
      }

      setTimeout(() => {
        firstQuestion.classList.remove("position-right-outside");
      }, 500);
    }

    // Remove old answer button event listeners and add new ones
    const answerButtons = document.querySelectorAll(".answer-button");
    answerButtons.forEach((button) => {
      const newButton = button.cloneNode(true);
      button.parentNode.replaceChild(newButton, button);

      newButton.addEventListener("click", () => {
        const questionElement = newButton.closest(".question");
        selectAnswer(
          newButton,
          questionElement,
          questionsBoxes,
          questionContainer
        );
      });
    });
  });
});

const handleQuestionNumber = (questionElement) => {
  const questionNumber = questionElement.querySelector(".question-number");
  if (questionNumber) {
    questionNumber.textContent = `${QUESTION_PREFIX} ${currentQuestionNumber}: `;
  }
};
